export default __webpack_public_path__ + "static/media/339.460d276e.gif";